import { render, staticRenderFns } from "./SpeakingPhonics2.vue?vue&type=template&id=4c0447b1&scoped=true&"
import script from "./SpeakingPhonics2.vue?vue&type=script&lang=js&"
export * from "./SpeakingPhonics2.vue?vue&type=script&lang=js&"
import style0 from "./SpeakingPhonics2.vue?vue&type=style&index=0&id=4c0447b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0447b1",
  null
  
)

export default component.exports